import React, { useEffect, useState } from "react";
import __ from "lodash";
import Dialog from "../../../controls/Dialog";
import { Table, TableBody, TableCell, TableHead, TableRow, makeStyles } from "@material-ui/core";
import NumberFormat from "react-number-format";

const tableStyles = (theme) => ({
  fuelAnalysis: {
    '& .MuiTableHead-root .MuiTableRow-root': {
      backgroundColor: "#e0e0e0",
    },
    '& .MuiTableCell-root': {
      border: "1px solid #c0c0c0",
      padding: 5
    },
    '& .MuiTableCell-root.headerCell': {
      backgroundColor: "#c0c0c0",
      fontWeight: "bold"
    }
  },
});

const FuelAnalysisGrid = (props) => {

  const classes = makeStyles(tableStyles)();

  const headings = [
    { name: 'CARGO', field: 'cargo', text: true },
    { name: 'PAYLOAD', field: 'payloadOnboard', suffix: "kg" },
    { name: 'FUEL POLICY', field: 'fuelPolicy', text: true },
    { name: 'ARRIVAL FUEL - 3T', field: 'arrivalFuel' },
    { name: 'DEPARTURE FUEL', field: 'departureFuel' },
    { name: 'FUEL OVER DEST', field: 'fod' },
    { name: 'UPLIFT REQUIRED', field: 'fuelToUplift' },
    { name: 'UPLIFT REQUIRED (USG)', field: 'fuelToUpliftUSG' },
    { name: 'FUEL PRICE (USD)', field: 'fuelPrice', prefix: "$", decimalScale: 5 },
    { name: 'TOTAL FUEL COST (USD)', field: 'totalFuelCost', prefix: "$", decimalScale: 2 },
  ];

  const data = props.legs.map(leg => {
    const planData = leg?.planData || {}
    return {
      cargo: `${leg.originAirportCode}-${leg.destinationAirportCode}`,
      payloadOnboard: leg.payloadOnboard,
      fuelPolicy: planData.fuelPolicyType,
      arrivalFuel: planData.openingFuel,
      departureFuel: planData.departureFuel,
      fod: planData.fod,
      fuelToUplift: planData.fuelToUplift,
      fuelToUpliftUSG: planData.fuelToUplift/3.04,
      fuelPrice: leg.fuelPrice,
      totalFuelCost: planData.fuelCost,
    }
  });  

  return (
    <Table className={classes.fuelAnalysis}>
      <TableHead>
        <TableRow>
          <TableCell width="180px">&nbsp;</TableCell>
          <TableCell align="center" className="headerCell" colspan={data.length}>Sector</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {headings.map((row) => (
          <TableRow key={row.name}>
            <TableCell className="headerCell">{row.name}</TableCell>
            {data.map((record) => (
              <TableCell width="100px" key={record[row.field]} align={row.text?"center":"right"}>
                {row.text?<>{record[row.field]}</>:<NumberFormat value={record[row.field]} displayType='text' thousandSeparator={true} decimalScale={row.decimalScale || 0} prefix={row.prefix} suffix={row.suffix} />}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

const ViewFuelAnalysis = (props) => {
  const {SystemData} = props;
  const eventBus = SystemData.eventBus;

  const [dialogStates, setDialogStates] = useState({
    showDialog: false,
    options: null,
    record: null
  });

  useEffect(()=> {
    const open = async (params) => {
      setDialogStates(
        {
          ...dialogStates,
          showDialog:true,
          options: params.options,
          record: params?.record||null,
        }
      );
    }
    eventBus.bind("ViewFuelAnalysis.open", open);

    return () => {
      eventBus.unbind("ViewFuelAnalysis.open", open);
    }
  }, [dialogStates, eventBus]);

  if (dialogStates.showDialog) {
    return (
      <Dialog 
        open={dialogStates.showDialog}
        title="Fuel Analysis"
        message=""
        buttons={{
          cancel:{icon: "cancel", key: "Close", label: "Close", color: "primary"}
        }}
        onChange={(state) => {
          setDialogStates({...dialogStates, showDialog: false, options: null, record: null});
        }}
        maxWidth={770}
      >
        {dialogStates.record && Array.isArray(dialogStates.record.legs) ?
        <div>
          <FuelAnalysisGrid legs={dialogStates.record.legs}/>
        </div>
        : <div>No Fuel Analysis to show</div>}
      </Dialog>
    );  
  }
  return null;
}

export default ViewFuelAnalysis;